import { useOutletContext } from "react-router-dom";

const useAuthContext = () => {
  return useOutletContext();
};

export default useAuthContext;
